module.exports = __webpack_public_path__ + "static/media/plus-sign.e2f09861.svg";